import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n, LangSwitch } from "../context/I18nContext";
import Logo from "./Logo";
import { House, Calendar, Tooth, Receipt, ChatCircleDots, SignOut, CalendarPlus } from "@phosphor-icons/react";

const NAV_DEF = [
  { to: "/portal", key: "overview", icon: House, end: true },
  { to: "/portal/book", key: "book", icon: CalendarPlus },
  { to: "/portal/appointments", key: "appts", icon: Calendar },
  { to: "/portal/history", key: "history", icon: Tooth },
  { to: "/portal/invoices", key: "invoices", icon: Receipt },
  { to: "/portal/enquiry", key: "enquiry", icon: ChatCircleDots },
];

export default function PortalLayout() {
  const { user, logout } = useAuth();
  const { t, lang } = useI18n();
  const navigate = useNavigate();
  const doLogout = async () => {
    await logout();
    navigate("/login");
  };
  const fontFamily = lang === "hi" ? "Hind, Manrope, sans-serif" : "Manrope, sans-serif";
  return (
    <div className="min-h-screen bg-[#FAFAFA]" style={{ fontFamily }}>
      <header className="bg-white border-b border-zinc-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between gap-3">
          <Link to="/portal" className="flex items-center gap-3">
            <Logo size={40} withText />
          </Link>
          <div className="flex items-center gap-3">
            <LangSwitch />
            <div className="hidden sm:block text-right">
              <div className="text-sm font-semibold text-zinc-900">{user?.name}</div>
              <div className="text-xs text-zinc-500">{user?.email}</div>
            </div>
            <button
              onClick={doLogout}
              className="flex items-center gap-2 bg-zinc-900 hover:bg-zinc-800 text-white text-sm font-semibold rounded-sm px-4 py-2"
              data-testid="logout-button"
            >
              <SignOut size={16} weight="bold" /> {t("common.signout")}
            </button>
          </div>
        </div>
        <div className="border-t border-zinc-100">
          <div className="max-w-6xl mx-auto px-4 sm:px-8 flex gap-1 overflow-x-auto">
            {NAV_DEF.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-3 text-sm whitespace-nowrap border-b-2 transition-colors ${
                    isActive
                      ? "border-[#E60000] text-zinc-900 font-semibold"
                      : "border-transparent text-zinc-500 hover:text-zinc-900"
                  }`
                }
                data-testid={`portal-nav-${n.key}`}
              >
                <n.icon size={16} weight="bold" />
                {t(`portal.nav_${n.key}`)}
              </NavLink>
            ))}
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
        <Outlet />
      </main>
      <footer className="border-t border-zinc-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-8 py-6 flex items-center justify-between text-xs text-zinc-500">
          <span>© Dr Tayyeb&apos;s Dental &amp; Maxillofacial Centre · Unchwa, GKP</span>
          <span className="text-[10px] uppercase tracking-[0.25em]">{lang === "hi" ? "मरीज़ पोर्टल" : "Patient Portal"}</span>
        </div>
      </footer>
    </div>
  );
}
